<template>
<div style=" min-width: 1024px;max-width: 1680px;margin:0 auto;">
    <HeadTop />
    <div class="comment">
        <div class="comLeft">
            <a-tabs default-active-key="2" @change="callback">
                <a-tab-pane key="2" tab="收到的评论">
                    <a-empty style="margin-top:150px;" v-if="total==0" />
                    <div v-if="publishListLeft.length>0"  class="commentList2">
                        <div class="mes1" v-for="(item,index) in publishListLeft" :key="index">
                            <div class="mesLeft2">
                                <img v-if="item.recuserPhoto" class="userImg" :src="$userINfoBasePath+'/'+item.recuserPhoto" alt="" />
                            </div>
                            <div class="mesRight2">
                                <div class="text_top"><span class="name">{{item.userName}}</span> <span class="someBody">评论</span> <span class="someBody">{{item.recuserName}}</span></div>
                                <div class="content">{{item.commentContent}}</div>
                                <ul class="comment_sl">
                                    <li class="mes_two">
                                        <div class="mes_twoLeft">
                                            <img v-if="item.publishUserPhoto" class="userImg" :src="$userINfoBasePath+'/'+item.publishUserPhoto" alt="" />
                                        </div>
                                        <div class="mes_twoRight">
                                            <div><span class="name">{{item.publishUserName}}</span></div>
                                            <div class="content">{{item.content}}</div>
                                        </div>
                                    </li>
                                </ul>
                                <div style="margin:10px 0px;">
                                    <span class="replyFun" @click="saySelf(index)">回复</span>
                                    <span class="date">{{format.format(item.createDate)}}</span>
                                </div>
                                <div class="fb_box" v-show="index===targetIndex">
                                    <a-textarea v-model="myPublishReplayValue" :auto-size="{ minRows: 2, maxRows: 2}" />
                                    <div class="fb_d">
                                        <a-button class="fb" type="primary" @click="determine(item,2)">发布</a-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="text-align:center;margin-top:20px;height:50px;">
                        <a-config-provider>
                        <a-pagination
                            show-quick-jumper
                            :default-current="1"
                            :page-size="pageSize"
                            @change="handleListChange"
                            show-less-items
                            :total=total />
                        </a-config-provider>
                    </div>
                </a-tab-pane>
                <a-tab-pane key="1" tab="发出的评论" force-render>
                    <a-empty style="margin-top:150px;" v-if="total==0" />
                    <div v-if="publishListLeft.length>0" class="commentList1">
                        <div class="mes1" v-for="(item,index) in publishListLeft" :key="index">
                            <div class="mesLeft1">
                                <img v-if="item.userPhoto" class="userImg" :src="$userINfoBasePath+'/'+item.userPhoto" alt="" />
                            </div>
                            <div class="mesRight1">
                                <div class="text_top"><span class="name">{{item.userName}}</span> <span class="someBody">评论</span> <span class="someBody">{{item.recuserName}}</span></div>
                                <div class="content">{{item.commentContent}}</div>
                                <ul class="comment_sl">
                                    <li class="mes_two">
                                        <div class="mes_twoLeft">
                                            <img v-if="item.publishUserPhoto" class="userImg" :src="$userINfoBasePath+'/'+item.publishUserPhoto" alt="" />
                                        </div>
                                        <div class="mes_twoRight">
                                            <div><span class="name">{{item.publishUserName}}</span></div>
                                            <div class="content">{{item.content}}</div>
                                        </div>
                                    </li>
                                </ul>
                                <div style="margin:10px 0px;">
                                    <span class="replyFun" @click="sendSelf(index)">回复</span>
                                    <span class="date">{{format.format(item.createDate)}}</span>
                                </div>
                                <div class="fb_box" v-show="index===myPublishTargetIndex">
                                    <a-textarea v-model="myPublishReplayValue" :auto-size="{ minRows: 2, maxRows: 2}" />
                                    <div class="fb_d">
                                        <a-button class="fb" type="primary" @click="determine(item,2)">发布</a-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="text-align:center;margin-top:20px;height:50px;">
                        <a-config-provider>
                        <a-pagination
                            show-quick-jumper
                            :default-current="1"
                            :page-size="pageSize"
                            @change="handleListChange"
                            show-less-items
                            :total=total />
                        </a-config-provider>
                    </div>
                </a-tab-pane>
            </a-tabs>
        </div>
        <div class="comRight">
            <div class="userDe">
                <div class="top">
                    <div class="user">
                        <img class="userImg" :src="userDetail.photo&&userDetail.photo!=null?$userINfoBasePath+'/'+userDetail.photo:'../../assets/imgs/teacher.png'" alt="" />
                        <span class="userName">{{userDetail.name}}</span>
                    </div>
                    <div class="userDetail">
                        <div class="left">
                            <div class="num">{{userMess.pushCount || 0}}</div>
                            <div class="text">我发布的</div>
                        </div>
                        <div class="right">
                            <div class="num">{{userMess.praiseNum || 0}}</div>
                            <div class="text">获赞</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="myRelease">
                <div class="myReplay">
                    <img class="messImg" src="../../assets/teacherRoad/27.png" alt="" />
                    <span class="text">我发布的</span>
                </div>
                <div v-if="publishListRight.length==0">
                    <a-empty style="margin-top:80px;" />
                </div>
                <div v-else>
                    <ul class="comList">
                        <li class="commentLi" v-for="(item,index) in publishListRight" :key="index">
                            {{item.commentContent}}
                        </li>
                    </ul>
                    <div class="lookAll" @click="lookAllFun">查看全部</div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import HeadTop from '@/components/HeadTop.vue'
import format from '@/utils/format.js'
export default {
    name: 'myComment',
    data(){
        return {
            format,
            resBasePath: this.$resBasePath,
            userDetail:this.$getUserInfo(),
            userMess: {}, //教师发布获赞信息
            publishListRight: [], // 我发布的
            publishListLeft: [],
            pageSize: 5,
            pageNum: 1,
            total: 0,
            myReplayValue: '', //收到的评论回复
            myPublishReplayValue: '', //发出的评论
            targetIndex: -1, //回复消息是否展示
            myPublishTargetIndex: -1, // 发出的评论是否展示
            type: 2

        }
    },
    mounted(){
        this.getTeacherCommentList()
        this.getpublishList()
    },
    methods:{
        //老师评论信息
        getTeacherCommentList(){
            this.$fetch({
                url: this.$baseUrl + 'ebook/teacher/exchangeSpace/getPushCountByUserId',
                body: {
                    userId: this.$getUserInfo().id
                }
            }).done(res =>{
                if(res && res.success && res.resultCode === 0){
                    this.userMess = res.resultData
                }
            })
        },
        //我的发布
        getpublishList(){
            const param = {
                type: this.type,
                userId: this.$getUserInfo().id,
                pageSize: this.pageSize,
                pageNum: this.pageNum
            }
            let _this = this
            _this.$fetch({
                url: _this.$baseUrl + 'ebook/teacher/exchangeSpace/getMyCommentPage',
                body: param
            }).done(res => {
                if(res && res.success && res.resultCode === 0){
                    _this.publishListRight = res.resultData.list.slice(0,3)
                    _this.publishListLeft = res.resultData.list
                    _this.total = res.resultData.total
                }
            })
        },
        saySelf(index){
            this.myPublishReplayValue = ''
            this.targetIndex = index
        },
        sendSelf(index){
            this.myPublishReplayValue = ''
            this.myPublishTargetIndex = index
        },
        determine (replyMess,type) {
            const param = {
                type: type,
                userId: this.$getUserInfo().id,
                reUserId: replyMess.userId, // 被回复ID
                rootId: replyMess.rootId, // 顶层互动提问id
                parentId: replyMess.id, // 被评论回复id type为1 时传 0
                content: this.myPublishReplayValue // 评论内容
            }
            // console.log(param)
            this.$fetch({
                url: this.$baseUrl + 'ebook/teacher/exchangeSpace/commentReply',
                body: param
            }).done(res => {
                if (res && res.success && res.resultCode === 0) {
                    this.$message.success('回复成功')
                    this.targetIndex = -1
                    this.myPublishTargetIndex = -1
                    this.getpublishList()
                }
            })
        },
        sendReply(item){ //发出的评论 type:2

        },
        handleListChange (current, pageSize) {
            this.pageNum = current
            this.pageSize = pageSize
            this.getpublishList()
        },
        callback(type) {
            this.type = Number(type)
            this.getpublishList()
        },
        lookAllFun(){
            this.$router.push({name: 'myPublish'})
        }
    },
    components:{
        HeadTop
    }
}
</script>

<style lang="less" soced>
    ul,li{
        margin: 0;
        padding: 0;
        list-style: none;
    }
    .comment{
        //width: 1240px;
        // height: 700px;
        margin: 0 auto;
        display: flex;
        // margin-top: 30px;
        /deep/.ant-tabs-bar{
            border-bottom: 1px solid #f0f0f0;
        }
        .comLeft{
            width: 900px;
            flex: 1;
            background: #fff;
            height: 100%;
            border-radius: 4px;
            min-height: 630px;
            .commentList2{
                //width: 900px;
                .mes1{
                    //width: 900px;
                    border-bottom: 1px solid #E6DDD0;
                    display: flex;
                    margin-top: 15px;
                    .mesLeft2{
                        width: 50px;
                        height: 100%;
                        margin-left: 20px;
                        .userImg{
                            width: 32px;
                            height: 32px;
                            border-radius: 50%;
                        }
                    }
                    .mesRight2{
                        //width: 800px;
                        height: 100%;
                        .text_top{
                            .name{
                                font-size: 16px;
                                font-family: PingFangSC-Semibold, PingFang SC;
                                font-weight: 600;
                                color: #000000;
                                line-height: 24px;
                            }
                            .someBody{
                                font-size: 16px;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #BDBDBD;
                                line-height: 24px
                            }
                        }
                        .name{
                            font-size: 16px;
                            font-family: PingFangSC-Semibold, PingFang SC;
                            font-weight: 600;
                            color: #000000;
                            line-height: 24px;
                        }
                        .content{
                            font-size: 18px;
                            font-family: STSongti-SC-Regular, STSongti-SC;
                            font-weight: 400;
                            color: #040506;
                            margin-top: 6px;
                        }
                        .comment_sl{
                            background: #f6f6f6;
                            width: 800px;
                            display: block;
                            padding: 0px 20px 20px 20px;
                            .mes_two{
                                margin-top: 8px;
                                // width: 660px;
                                padding-top: 20px;
                                display: flex;
                                .mes_twoLeft{
                                    height: 100%;
                                    .userImg{
                                        width: 32px;
                                        height: 32px;
                                        border-radius: 50%;
                                        margin-right:20px;
                                    }
                                }
                                .mes_twoRight{
                                    // width: 640px;
                                    height: 100%;
                                    .content{
                                        font-size: 18px;
                                        font-family: STSongti-SC-Regular, STSongti-SC;
                                        font-weight: 400;
                                        color: #040506;
                                        margin-top: 6px;
                                    }
                                }
                            }
                        }
                        .replyFun{
                            font-size: 12px;
                            font-family: PingFangSC-Semibold, PingFang SC;
                            font-weight: 600;
                            color: @primary-color;
                            line-height: 20px;
                            cursor: pointer;
                        }
                        .date{
                            font-size: 12px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #7F7F7F;
                            line-height: 20px;
                            float: right;
                        }
                        .fb_box{
                            .fb_d{
                                height: 35px;
                                margin-top: 10px;
                                text-align: right;
                                .fb{
                                    width: 80px;
                                    height: 24px;
                                    line-height: 24px;
                                    border-radius: 2px;
                                }
                            }
                        }
                    }
                }
            }
            .commentList1{
                width: 900px;
                .mes1{
                    width: 900px;
                    border-bottom: 1px solid #E6DDD0;
                    display: flex;
                    margin-top: 15px;
                    .mesLeft1{
                        width: 50px;
                        height: 100%;
                        margin-left: 20px;
                        .userImg{
                            width: 32px;
                            height: 32px;
                            border-radius: 50%;
                        }
                    }
                    .mesRight1{
                        //width: 800px;
                        height: 100%;
                        .text_top{
                            .name{
                                font-size: 16px;
                                font-family: PingFangSC-Semibold, PingFang SC;
                                font-weight: 600;
                                color: #000000;
                                line-height: 24px;
                            }
                            .someBody{
                                font-size: 16px;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #BDBDBD;
                                line-height: 24px
                            }
                        }
                        .name{
                            font-size: 16px;
                            font-family: PingFangSC-Semibold, PingFang SC;
                            font-weight: 600;
                            color: #000000;
                            line-height: 24px;
                        }
                        .content{
                            font-size: 18px;
                            font-family: STSongti-SC-Regular, STSongti-SC;
                            font-weight: 400;
                            color: #040506;
                            margin-top: 6px;
                        }
                        .comment_sl{
                            background: #f6f6f6;
                            width: 800px;
                            display: block;
                            padding: 0px 20px 20px 20px;
                            .mes_two{
                                margin-top: 8px;
                                // width: 660px;
                                padding-top: 20px;
                                display: flex;
                                .mes_twoLeft{
                                    height: 100%;
                                    .userImg{
                                        width: 32px;
                                        height: 32px;
                                        border-radius: 50%;
                                        margin-right:20px;
                                    }
                                }
                                .mes_twoRight{
                                    // width: 640px;
                                    height: 100%;
                                    .content{
                                        font-size: 18px;
                                        font-family: STSongti-SC-Regular, STSongti-SC;
                                        font-weight: 400;
                                        color: #040506;
                                        margin-top: 6px;
                                    }
                                }
                            }
                        }
                        .replyFun{
                            font-size: 12px;
                            font-family: PingFangSC-Semibold, PingFang SC;
                            font-weight: 600;
                            color: @primary-color;
                            line-height: 20px;
                            cursor: pointer;
                        }
                        .date{
                            font-size: 12px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #7F7F7F;
                            line-height: 20px;
                            float: right;
                        }
                        .fb_box{
                            .fb_d{
                                height: 35px;
                                margin-top: 10px;
                                text-align: right;
                                .fb{
                                    width: 80px;
                                    height: 24px;
                                    line-height: 24px;
                                    border-radius: 2px;
                                }
                            }
                        }
                    }
                }
            }
        }
        .comRight{
            width: 310px;
            margin-left: 30px;
            height: 100%;
            border-radius: 4px;
            .userDe{
                width: 100%;
                height: 200px;
                background: #fff;
                border-radius: 4px;
                    .user{
                    width: 150px;
                    margin: 0 auto;
                    padding-top: 30px;
                    // padding: 30px 90px 0px 30px;
                    .userImg{
                       width: 44px;
                       height: 44px;
                       text-align: center;
                       border-radius: 50%;
                       margin-top: -8px;
                    }
                    .userName{
                        width: 60px;
                        height: 40px;
                        font-size: 20px;
                        font-family: PingFangSC-Semibold, PingFang SC;
                        font-weight: 600;
                        color: #000000;
                        line-height: 40px;
                        margin-left: 20px;
                    }
                }
                .userDetail{
                    display: flex;
                    margin-top: 30px;
                    .left,.right{
                        width: 50%;
                        height: 40px;
                        text-align: center;
                        .num{
                            font-size: 16px;
                            font-family: AlibabaPuHuiTi-Bold, AlibabaPuHuiTi;
                            font-weight: bold;
                            font-weight: 600;
                            color: #A3AF90;
                        }
                        .text{
                            font-size: 12px;
                            font-family: AlibabaPuHuiTi-Bold, AlibabaPuHuiTi;
                            font-weight: bold;
                            font-weight: 400;
                            color: #000000;
                            line-height: 20px;
                        }
                    }
                    .left{
                        border-right: 1px solid #E6DDD0;
                    }
                    .right{
                        margin-left: 0px;
                    }
                }
            }
            .myRelease{
                width: 100%;
                height: 415px;
                background: #fff;
                border-radius: 4px;
                margin-top: 15px;
                padding: 30px;
                .myReplay{
                    height: 30px;
                    line-height: 30px;
                    .messImg{
                        width: 16px;
                        height: 14px;
                        margin-top: -4px;
                    }
                    .text{
                        margin-left: 10px;
                        font-size: 16px;
                        font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
                        font-weight: 400;
                        color: #999999;
                        line-height: 20px;
                    }
                }
            }
            .comList{
                height: 280px;
                border-bottom: 1px solid #E6DDD0;
                .commentLi{
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 3;
                    -webkit-box-orient: vertical;
                    font-size: 14px;
                    font-family: STSongti-SC-Regular, STSongti-SC;
                    font-weight: 400;
                    color: #040506;
                    margin-top: 30px;
                    &:first-child{
                        margin-top: 10px;
                    }
                }
            }
            .lookAll{
                cursor: pointer;
                margin-top: 10px;
                text-align: center;
                width: 100%;
                height: 40px;
                font-size: 14px;
                font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
                font-weight: 500;
                color: @primary-color;
                line-height: 40px;
            }
        }
    }
    /deep/.ant-tabs-bar{
        margin: 0px;
    }
</style>
